import React from 'react';
import { paths } from 'config/path_helpers';
import Accordion from '@magoosh/lib/accordion';
import { Hint } from './types';
import fetch from 'utilities/fetch';
import { renderLatexInRawHtml } from 'utilities/latex';

interface Props {
  hints: Hint[];
}

export const Hints: React.FC<Props> = (props) => {
  const markHintAsViewed = (hintId: number) => {
    return fetch(paths.api.markings(), {
      body: JSON.stringify({
        markableId: hintId,
        markableType: 'Hint',
        name: 'viewed'
      }),
      method: 'POST'
    });
  };

  return (
    <>
      {props.hints.map((hint, index) => (
        <div key={index}>
          <Accordion
            isOpen={hint.hasBeenViewed}
            onOpen={() => markHintAsViewed(hint.id)}
            title={`Hint ${index + 1}`}>
            <div dangerouslySetInnerHTML={{ __html: renderLatexInRawHtml(hint.content) }} />
          </Accordion>
        </div>
      ))}
    </>
  );
};

export default Hints;
